import {observer} from "mobx-react";
import {useStores} from "../../Hooks";
import {itemTypeEnum} from "../../enums";
import {Card} from "@mui/material";
import Utility from "../../Utility";
import EllipsisContainer from "../Shared/EllipsisContainer";
import Drag from "../DragDrop/Drag";
import React from "react";
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import SlideshowOutlinedIcon from '@mui/icons-material/SlideshowOutlined';
import ConditionalComponent from "../Shared/ConditionalComponent";
import {fileTypeEnum} from "../../serverClientShared/sharedEnums";
import {PhotoOutlined} from "@mui/icons-material";
import AdbOutlinedIcon from '@mui/icons-material/AdbOutlined';
import AppleIcon from '@mui/icons-material/Apple';
import LanguageIcon from '@mui/icons-material/Language';
import MicrosoftIcon from '@mui/icons-material/Microsoft';
 const  FileCard = observer((props) => {
    const {modalStore} = useStores();
    const {
        selectableRef,
        isSelected,
        isSelecting,
        file,
        dragged,
        somethingDragged,
        onCardHovered,
        onCardExited,
        setSelected,
        openContextMenu,
    } = props;

    const {preventRefreshProject} = modalStore.modalData;

    function renderDragChild() {
        const fileName = `${file.FileName}.${file.FileExtension}`;
        file.type = itemTypeEnum.FILE;

        let cardClassName = 'file-card';
        if (isSelected || isSelecting) {
            cardClassName += ' selected';
        }
        if (dragged) {
            cardClassName += ' dragged';
        }
        return (
            <Card
                onMouseEnter={() => isSelected && onCardHovered()}
                onMouseLeave={onCardExited}
                ref={selectableRef}
                className={cardClassName}
            >
                <div>
                    <ConditionalComponent if={file.FileType === fileTypeEnum.PDF}>
                        <PictureAsPdfOutlinedIcon size='small' />
                    </ConditionalComponent>
                    <ConditionalComponent if={file.FileType === fileTypeEnum.IMAGE}>
                        <PhotoOutlined size='small'/>
                    </ConditionalComponent>
                    <ConditionalComponent if={file.FileType === fileTypeEnum.VIDEO}>
                        <SlideshowOutlinedIcon size='small'/>
                    </ConditionalComponent>
                    <ConditionalComponent if={file.FileType === fileTypeEnum.FRONTLINE_ANDROID }>
                        <AdbOutlinedIcon size='small'/>
                    </ConditionalComponent>
                    <ConditionalComponent if={file.FileType === fileTypeEnum.FRONTLINE_IOS || file.FileType === fileTypeEnum.FRONTLINE_MAC}>
                        <AppleIcon size='small'/>
                    </ConditionalComponent>
                    <ConditionalComponent if={file.FileType === fileTypeEnum.FRONTLINE_WEB}>
                        <LanguageIcon size='small'/>
                    </ConditionalComponent>
                    <ConditionalComponent if={file.FileType === fileTypeEnum.FRONTLINE_WINDOWS}>
                        <MicrosoftIcon size='small'/>
                    </ConditionalComponent>
                <span className='thumbnail-container'>
                    {Utility.renderFileThumbnail(file)}
                </span>
                </div>
                <EllipsisContainer value={fileName}>
                    <div className='file-card-file-name'>
                        {fileName}
                    </div>
                </EllipsisContainer>
            </Card>
        );
    }


    return (
        <div onContextMenu={(e) => openContextMenu(e, file)}>
            {Utility.isMobile() || preventRefreshProject ? (
                <div onClick={() => {
                    setSelected([{props}]);
                }}>
                    {renderDragChild()}
                </div>
            ) : (
                <Drag
                    itemId={file.FileId}
                    itemType={itemTypeEnum.FILE}
                    isSlave={isSelected && somethingDragged}
                >
                    {renderDragChild()}
                </Drag>
            )}
        </div>
    )
});
export default FileCard;
